import { Model, Post, User } from "@/models";

export default class Like extends Model {
  static type = "likes";
  post!: Post;
  user!: User;
}
